export const Texts = {
    ALL_ITEM_CODE_OPTION: 'todo',
    ALL_ITEM_DESCRIPTION_OPTION: 'TODO',
    NO_OPTION_DESCRIPTION: 'Ninguna'
}
